import { supabase } from '../supabaseClient'

/**
 * Envia o PDF da procuração para a Clicksign para assinatura eletrônica.
 * Use storage_path (recomendado para PDFs grandes) OU content_base64.
 * @param {Object} params
 * @param {string} [params.content_base64] - Conteúdo do PDF em base64 (data URL ou base64). Use este OU storage_path.
 * @param {string} [params.storage_path] - Caminho do PDF no Storage (bucket padrão: clicksign-uploads). Evita truncar body.
 * @param {string} [params.storage_bucket] - Bucket. Padrão: clicksign-uploads
 * @param {string} params.filename - Nome do arquivo (ex: Procuração_Cliente_2025-02-28.pdf)
 * @param {'email'|'whatsapp'|'both'} params.send_via - Canal de envio: e-mail, WhatsApp ou ambos
 * @param {Object} [params.signer] - Dados de um único signatário (retrocompat). Prefira `signers`.
 * @param {string} params.signer.name - Nome completo
 * @param {string} params.signer.documentation - CPF (apenas números, 11 dígitos)
 * @param {string} [params.signer.email] - E-mail (obrigatório se send_via for email ou both)
 * @param {string} [params.signer.phone_number] - Telefone só dígitos 10-11 (obrigatório se send_via for whatsapp ou both)
 * @param {Array<Object>} [params.signers] - Lista de signatários que assinam o MESMO documento (mesma estrutura de `signer`). Tem prioridade sobre `signer`.
 * @param {string} [params.notification_sender_name] - Nome do remetente na notificação (ex.: "ConectSolar"). Mensagem enviada: "{nome} enviou 1 documento pela Clicksign para você assinar."
 * @returns {Promise<{ success: boolean, signing_url?: string, document_key?: string, message?: string, error?: string }>}
 */
export async function enviarProcuracaoParaClicksign({ content_base64, storage_path, storage_bucket, filename, send_via, signer, signers, notification_sender_name }) {
  let data
  let error
  try {
    const body = { filename, send_via }
    if (Array.isArray(signers) && signers.length > 0) {
      body.signers = signers
    } else if (signer) {
      body.signer = signer
    }
    if (notification_sender_name != null && String(notification_sender_name).trim()) {
      body.notification_sender_name = String(notification_sender_name).trim()
    }
    if (storage_path) {
      body.storage_path = storage_path
      if (storage_bucket) body.storage_bucket = storage_bucket
    } else {
      body.content_base64 = content_base64
    }
    const result = await supabase.functions.invoke('clicksign-procuracao', {
      body
    })
    data = result?.data
    error = result?.error
  } catch (e) {
    console.error('[Clicksign] Exceção ao chamar Edge Function:', e)
    return {
      success: false,
      error: (e && e.message) || 'Falha ao chamar o serviço de assinatura. Verifique o console (F12) para detalhes.'
    }
  }

  // Erro retornado no body (200 com success: false) tem prioridade sobre error do cliente
  if (data && (data.error || data.success === false)) {
    const msg = data.error || 'Erro ao processar na Clicksign.'
    console.error('[Clicksign] Resposta de erro da função:', msg, data)
    return { success: false, error: msg }
  }

  if (error) {
    const msg = data?.error || error.message || error?.error?.message || 'Falha ao chamar o serviço de assinatura. Tente novamente ou veja o console (F12).'
    console.error('[Clicksign] Erro da chamada:', error, 'data:', data)
    return { success: false, error: msg }
  }

  return {
    success: true,
    signing_url: data?.signing_url,
    document_key: data?.document_key,
    document_id: data?.document_id,
    message: data?.message || 'Documento enviado para assinatura.'
  }
}
